// Public API for Zone
export {NgZone, NgZoneError} from './zone/ng_zone';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
